import { useQueryClient } from '@tanstack/react-query'
import { SavedView } from 'models/saved_view'
import { toast } from 'react-toastify'
import apiService from 'services/api'
import { SavedFilterFormData, SavedFilterModal } from './SavedFilterModal'

interface EditSavedFilterModalProps {
  show: boolean
  handleClose: () => void
  savedFilter: SavedView | null
  onFilterUpdated?: () => void
}

export function EditSavedFilterModal({
  show,
  handleClose,
  savedFilter,
  onFilterUpdated,
}: EditSavedFilterModalProps) {
  const api = apiService()
  const queryClient = useQueryClient()

  const handleSubmitSuccess = () => {
    toast.success('Filter updated!')
    onFilterUpdated?.()
  }

  const updateFilter = async (values: SavedFilterFormData) => {
    if (!savedFilter) return

    await api.updateFilter(savedFilter.id, {
      name: values.name,
      shared: values.shared,
    })

    // Invalidate saved filters for the specific identifier
    await queryClient.invalidateQueries({
      queryKey: ['saved_filters', savedFilter.identifier],
    })

    // Invalidate all saved filters (for settings table)
    await queryClient.invalidateQueries({
      queryKey: ['saved-views/'],
    })
  }

  return (
    <SavedFilterModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Update"
      submitApiAction={updateFilter}
      savedFilterToEdit={savedFilter}
      title="Edit Filter"
      description="Update the filter name and sharing settings."
    />
  )
}
